import { Link } from "wouter";
import { FaCheckCircle, FaMedal, FaTools, FaHandshake, FaLightbulb } from "react-icons/fa";

const About = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-primary">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">За нас</h1>
            <p className="text-xl text-white max-w-2xl mx-auto">
              V&M Group Ltd – Вашият надежден партньор за качествени довършителни работи в София
            </p>
          </div>
        </div>
      </section>

      {/* Main About Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-10">
            <div className="md:w-1/2">
              <img 
                src="/about-us.avif" 
                alt="Професионални довършителни работи от V&M Group" 
                className="rounded-lg shadow-lg w-full h-auto object-cover"
              />
            </div>
            
            <div className="md:w-1/2">
              <h3 className="text-2xl font-heading font-bold text-primary mb-4">
                Професионализъм и качество при всеки проект
              </h3>
              <p className="mb-4 text-gray-700">
                V&M Group Ltd е екип от висококвалифицирани професионалисти, специализирани в предоставянето на първокласни довършителни строителни услуги в София и региона. Ние сме посветени на това да предоставяме изключително качество на изпълнение, персонализирани решения и безупречно обслужване на клиентите.
              </p>
              
              <p className="mb-6 text-gray-700">
                Нашата мисия е да трансформираме вашите пространства в красиви, функционални и трайни среди, които надминават очакванията ви. Независимо дали става въпрос за шпакловка, боядисване или други довършителни работи, ние влагаме същото внимание към детайла и стремеж към съвършенство.
              </p>
              
              <ul className="space-y-2 mb-8">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#D95204] mt-1 mr-2" />
                  <span>Прецизност и внимание към всеки детайл</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#D95204] mt-1 mr-2" />
                  <span>Спазване на сроковете и договорените условия</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#D95204] mt-1 mr-2" />
                  <span>Индивидуален подход към всеки клиент и проект</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#D95204] mt-1 mr-2" />
                  <span>Безкомпромисно качество на изпълнение</span>
                </li>
              </ul>
              
              <Link href="/contact">
                <button className="inline-block bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-lg transition duration-300">
                  Свържете се с нас
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Нашите ценности</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Основните принципи, които ръководят работата ни и гарантират Вашето удовлетворение
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaMedal className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Качество</h3>
              <p className="text-gray-700">
                Използваме само висококачествени материали и прилагаме най-добрите техники, за да постигнем отлични и дълготрайни резултати.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaTools className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Професионализъм</h3>
              <p className="text-gray-700">
                Нашият екип от опитни специалисти работи с внимание към всеки детайл и се стреми към технически съвършени решения.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaHandshake className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Надеждност</h3>
              <p className="text-gray-700">
                Спазваме стриктно сроковете и бюджета, като работим прозрачно и поддържаме ясна комуникация на всеки етап от проекта.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaLightbulb className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Иновация</h3>
              <p className="text-gray-700">
                Следим най-новите тенденции и технологии в бранша, за да предлагаме модерни и ефективни решения за вашите проекти.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Approach Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Нашият подход</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Как работим, за да постигнем най-добрите резултати за Вашия проект
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
              <div className="flex items-center justify-center bg-primary text-white rounded-full w-12 h-12 flex-shrink-0 mt-1">
                <span className="font-bold">1</span>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-primary mb-2">Консултация и оценка</h3>
                <p className="text-gray-700">
                  Започваме с детайлна консултация, за да разберем точно вашите нужди и цели. След това извършваме обстоен оглед на обекта, за да оценим обхвата на работата и да идентифицираме потенциални предизвикателства.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
              <div className="flex items-center justify-center bg-primary text-white rounded-full w-12 h-12 flex-shrink-0 mt-1">
                <span className="font-bold">2</span>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-primary mb-2">Персонализирана оферта</h3>
                <p className="text-gray-700">
                  Изготвяме подробна и прозрачна оферта, съобразена с вашия бюджет и изисквания. Ясно описваме обхвата на работа, използваните материали, сроковете и цените, без скрити такси или изненади.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
              <div className="flex items-center justify-center bg-primary text-white rounded-full w-12 h-12 flex-shrink-0 mt-1">
                <span className="font-bold">3</span>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-primary mb-2">Прецизно изпълнение</h3>
                <p className="text-gray-700">
                  Нашият екип от професионалисти работи с внимание към всеки детайл, спазвайки най-високите стандарти за качество. Поддържаме редовна комуникация с вас през целия процес, за да гарантираме вашето удовлетворение.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="flex items-center justify-center bg-primary text-white rounded-full w-12 h-12 flex-shrink-0 mt-1">
                <span className="font-bold">4</span>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-primary mb-2">Финална инспекция</h3>
                <p className="text-gray-700">
                  След приключване на работата, извършваме щателна инспекция, за да гарантираме, че всичко отговаря на нашите високи стандарти. Приемаме проекта за завършен само когато вие сте напълно удовлетворени от резултата.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-6">Готови ли сте да започнем вашия проект?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Свържете се с нас сега за безплатна консултация и персонализирана оферта за вашия ремонт или строителен проект.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link href="/contact">
              <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 flex items-center justify-center gap-2">
                <span>ПОИСКАЙ ОФЕРТА</span>
                <span className="text-lg">→</span>
              </button>
            </Link>
            <Link href="tel:+359877338382">
              <button className="bg-white hover:bg-gray-100 text-primary font-bold py-3 px-8 rounded-lg transition duration-300 flex items-center justify-center gap-2">
                <span className="text-lg">📞</span>
                <span>087 733 8382</span>
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
